import { AuthEffects } from "./auth.effects";
import { NotificationEffects } from "./notification.effects";
import { TeacherEffects } from "./teacher.effects";

export const EFFECTS = [AuthEffects, NotificationEffects, TeacherEffects];

export * from "./auth.effects";
export * from "./notification.effects";
export * from "./teacher.effects";
